<section
  [class]="
    hasBorder()
      ? 'rounded-[20px] border border-slate-200 bg-white p-4 shadow-[0_1px_2px_rgba(15,23,42,0.04)] md:p-5'
      : 'pt-2'
  "
>
  <div class="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
    <div class="flex items-center gap-4">
      @if (icon(); as icon) {
        <div
          class="section-icon flex h-12 w-12 items-center justify-center rounded-2xl"
          [ngClass]="`bg-${iconColor()}-50 text-${iconColor()}-500`"
        >
          <i [attr.class]="icon"></i>
        </div>
      }
      <h3 class="section-title m-0 font-semibold leading-none tracking-[-0.02em] text-slate-900">
        {{ title() }}
      </h3>
    </div>

    <ng-content select="[actions]" />
  </div>

  <ng-content select="[content]" />
</section>
